module.exports = __webpack_public_path__ + "source/img/logo.38869bad.png";